import {formatCurrency} from "~/utils";
import '../style/ProductItem.css';

const ProductItem = ({product, onAdd, appData}) =>
{
    let price = product.price;

    if(product.unit === 'kg')
    {
        price = price * 10;
    }

    return (
        <div className="pos-product-item" onClick={() => onAdd(product)}>
            <div className="pos-product-info">
                <h4 className="pos-product-title">{product.title}</h4>
                <div className={'d-flex'} style={{gap:'5px'}}>
                    {product.attribute_label && (
                        <span className="pos-product-attribute">{product.attribute_label}</span>
                    )}
                </div>
            </div>
            <div className="pos-product-details">
                <div className="pos-product-price">
                    <span className="price-label">Giá:</span>
                    <span className="price-value">
                        {formatCurrency(price)}/ <span className={`stock-value ${product.unit === 'kg' ? 'out-of-stock' : ''}`}>
                        {product.unit === 'kg' ? '1 kg' : appData['units'][product.unit]?.label }
                    </span>
                    </span>
                </div>
                <div className="pos-product-vat">
                    <span className="vat-label">Thuế:</span>
                    <span className="vat-value">{product.vat}%</span>
                </div>
            </div>
        </div>
    );
};

export default ProductItem;
